import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEivPayerAetnaIcon = lazy(() => import('./svg-components/eiv-payer-aetna-icon'));

const EivPayerAetnaIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEivPayerAetnaIcon {...rest} />
  </Suspense>
);

export default EivPayerAetnaIcon;
